import React, { useState } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import Cms from "./cms";
import {
    getThumbnailUrl,
    getVideoSources,
    getWebmVideoUrl
} from "../utils/videoService";

function Hero({
    cmsContent,
    animationVideoId,
    animationThumbnail
}) {
    const [animationLoading, setAnimationLoading] = useState(true);

    // Get video URLs from service if animationVideoId is provided
    const webmVideoUrl = animationVideoId
        ? getWebmVideoUrl(animationVideoId)
        : null;
    const videoSources = animationVideoId
        ? getVideoSources(animationVideoId)
        : [];
    const thumbnailUrl = animationVideoId
        ? getThumbnailUrl(animationVideoId)
        : animationThumbnail;

    const handleVideoLoaded = () => {
        setAnimationLoading(false);
    };

    return (
        <>
            <Helmet>
                {webmVideoUrl && (
                    <link
                        rel="preload"
                        href={webmVideoUrl}
                        as="video"
                        type="video/webm"
                    />
                )}
                {videoSources.length > 0 && videoSources.find(s => s.type === "video/mp4") && (
                    <link
                        rel="preload"
                        href={videoSources.find(s => s.type === "video/mp4").src}
                        as="video"
                        type="video/mp4"
                    />
                )}
                {thumbnailUrl && (
                    <link rel="preload" href={thumbnailUrl} as="image" />
                )}
            </Helmet>

            <section className="outside-wrapper container-fluid">
                <div className="box box--end container flex-row homepage_hero">
                    <div className="col-xs-12 col-md-8 text-center">
                        <h2 className="title--banner text--red">
                            <Cms
                                content={cmsContent}
                                content_key="homepage_hero"
                                type="title"
                            />
                        </h2>
                        <p className="paragraph paragraph--small">
                            <Cms
                                content={cmsContent}
                                content_key="homepage_hero"
                                type="text"
                            />
                        </p>

                        <div className="buttons_wrapper">
                            <div
                                className="contact"
                                data-toggle="modal"
                                data-target="#contact"
                            >
                                <button
                                    type="button"
                                    className="btn-block-mobile btn btn-lg btn-primary"
                                >
                                    Try Reelmetrics for free
                                </button>
                            </div>
                            <a
                                href="/slot-machine-data-analytics-platform"
                                className="platform"
                            >
                                <button
                                    type="button"
                                    className="btn-block-mobile btn btn-lg btn-transparent"
                                >
                                    Explore Reelmetrics PLatform
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className="homepage_animation">
                {thumbnailUrl && (
                    <img
                        src={thumbnailUrl}
                        alt="animation_thumbnail"
                        className="animation_thumbnail"
                        style={{ opacity: animationLoading ? "0.75" : "0" }}
                    />
                )}
                {videoSources.length > 0 && (
                    <video
                        className="video-background-video"
                        autoPlay
                        loop
                        muted
                        playsInline
                        onCanPlay={handleVideoLoaded}
                        style={{
                            opacity: animationLoading ? "0" : "1",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            // height: "100%",
                            objectFit: "cover",
                            pointerEvents: "none",
                            zIndex: 1
                        }}
                    >
                        {videoSources.map((source) => (
                            <source
                                key={source.type}
                                src={source.src}
                                type={source.type}
                            />
                        ))}
                        Your browser does not support the video tag.
                    </video>
                )}
            </section>
        </>
    );
}

Hero.propTypes = {
    cmsContent: PropTypes.object.isRequired,
    animationThumbnail: PropTypes.string,
    animationVideoId: PropTypes.string
};

Hero.defaultProps = {
    animationVideoId: "521339921",
    animationThumbnail: ""
};

export default Hero;
